//
// Autogenerated by Thrift Compiler (0.13.0)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//
"use strict";

var thrift = require('thrift');
var Thrift = thrift.Thrift;
var Q = thrift.Q;
var Int64 = require('node-int64');


var ttypes = require('./categories-api_types');
//HELPER FUNCTIONS AND STRUCTURES

var CategoriesService_getAllCategories_args = function(args) {
};
CategoriesService_getAllCategories_args.prototype = {};
CategoriesService_getAllCategories_args.prototype.read = function(input) {
  input.readStructBegin();
  while (true) {
    var ret = input.readFieldBegin();
    var ftype = ret.ftype;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    input.skip(ftype);
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

CategoriesService_getAllCategories_args.prototype.write = function(output) {
  output.writeStructBegin('CategoriesService_getAllCategories_args');
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

var CategoriesService_getAllCategories_result = function(args) {
  this.success = null;
  if (args) {
    if (args.success !== undefined && args.success !== null) {
      this.success = Thrift.copyList(args.success, [ttypes.CategoryTO]);
    }
  }
};
CategoriesService_getAllCategories_result.prototype = {};
CategoriesService_getAllCategories_result.prototype.read = function(input) {
  input.readStructBegin();
  while (true) {
    var ret = input.readFieldBegin();
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid) {
      case 0:
      if (ftype == Thrift.Type.LIST) {
        this.success = [];
        var _rtmp31 = input.readListBegin();
        var _size0 = _rtmp31.size || 0;
        for (var _i2 = 0; _i2 < _size0; ++_i2) {
          var elem3 = null;
          elem3 = new ttypes.CategoryTO();
          elem3.read(input);
          this.success.push(elem3);
        }
        input.readListEnd();
      } else {
        input.skip(ftype);
      }
      break;
      case 0:
        input.skip(ftype);
        break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

CategoriesService_getAllCategories_result.prototype.write = function(output) {
  output.writeStructBegin('CategoriesService_getAllCategories_result');
  if (this.success !== null && this.success !== undefined) {
    output.writeFieldBegin('success', Thrift.Type.LIST, 0);
    output.writeListBegin(Thrift.Type.STRUCT, this.success.length);
    for (var iter4 in this.success) {
      if (this.success.hasOwnProperty(iter4)) {
        iter4 = this.success[iter4];
        iter4.write(output);
      }
    }
    output.writeListEnd();
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

var CategoriesService_saveCategory_args = function(args) {
  this.category = null;
  if (args) {
    if (args.category !== undefined && args.category !== null) {
      this.category = new ttypes.UpdatedCategory(args.category);
    }
  }
};
CategoriesService_saveCategory_args.prototype = {};
CategoriesService_saveCategory_args.prototype.read = function(input) {
  input.readStructBegin();
  while (true) {
    var ret = input.readFieldBegin();
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid) {
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.category = new ttypes.UpdatedCategory();
        this.category.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 0:
        input.skip(ftype);
        break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

CategoriesService_saveCategory_args.prototype.write = function(output) {
  output.writeStructBegin('CategoriesService_saveCategory_args');
  if (this.category !== null && this.category !== undefined) {
    output.writeFieldBegin('category', Thrift.Type.STRUCT, 1);
    this.category.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

var CategoriesService_saveCategory_result = function(args) {
};
CategoriesService_saveCategory_result.prototype = {};
CategoriesService_saveCategory_result.prototype.read = function(input) {
  input.readStructBegin();
  while (true) {
    var ret = input.readFieldBegin();
    var ftype = ret.ftype;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    input.skip(ftype);
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

CategoriesService_saveCategory_result.prototype.write = function(output) {
  output.writeStructBegin('CategoriesService_saveCategory_result');
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

var CategoriesServiceClient = exports.Client = function(output, pClass) {
  this.output = output;
  this.pClass = pClass;
  this._seqid = 0;
  this._reqs = {};
};
CategoriesServiceClient.prototype = {};
CategoriesServiceClient.prototype.seqid = function() { return this._seqid; };
CategoriesServiceClient.prototype.new_seqid = function() { return this._seqid += 1; };

CategoriesServiceClient.prototype.getAllCategories = function(callback) {
  this._seqid = this.new_seqid();
  if (callback === undefined) {
    var _defer = Q.defer();
    this._reqs[this.seqid()] = function(error, result) {
      if (error) {
        _defer.reject(error);
      } else {
        _defer.resolve(result);
      }
    };
    this.send_getAllCategories();
    return _defer.promise;
  } else {
    this._reqs[this.seqid()] = callback;
    this.send_getAllCategories();
  }
};

CategoriesServiceClient.prototype.send_getAllCategories = function() {
  var output = new this.pClass(this.output);
  var args = new CategoriesService_getAllCategories_args();
  try {
    output.writeMessageBegin('getAllCategories', Thrift.MessageType.CALL, this.seqid());
    args.write(output);
    output.writeMessageEnd();
    return this.output.flush();
  }
  catch (e) {
    delete this._reqs[this.seqid()];
    if (typeof output.reset === 'function') {
      output.reset();
    }
    throw e;
  }
};

CategoriesServiceClient.prototype.recv_getAllCategories = function(input,mtype,rseqid) {
  var callback = this._reqs[rseqid] || function() {};
  delete this._reqs[rseqid];
  if (mtype == Thrift.MessageType.EXCEPTION) {
    var x = new Thrift.TApplicationException();
    x.read(input);
    input.readMessageEnd();
    return callback(x);
  }
  var result = new CategoriesService_getAllCategories_result();
  result.read(input);
  input.readMessageEnd();

  if (null !== result.success) {
    return callback(null, result.success);
  }
  return callback('getAllCategories failed: unknown result');
};

CategoriesServiceClient.prototype.saveCategory = function(category, callback) {
  this._seqid = this.new_seqid();
  if (callback === undefined) {
    var _defer = Q.defer();
    this._reqs[this.seqid()] = function(error, result) {
      if (error) {
        _defer.reject(error);
      } else {
        _defer.resolve(result);
      }
    };
    this.send_saveCategory(category);
    return _defer.promise;
  } else {
    this._reqs[this.seqid()] = callback;
    this.send_saveCategory(category);
  }
};

CategoriesServiceClient.prototype.send_saveCategory = function(category) {
  var output = new this.pClass(this.output);
  var params = {
    category: category
  };
  var args = new CategoriesService_saveCategory_args(params);
  try {
    output.writeMessageBegin('saveCategory', Thrift.MessageType.CALL, this.seqid());
    args.write(output);
    output.writeMessageEnd();
    return this.output.flush();
  }
  catch (e) {
    delete this._reqs[this.seqid()];
    if (typeof output.reset === 'function') {
      output.reset();
    }
    throw e;
  }
};

CategoriesServiceClient.prototype.recv_saveCategory = function(input,mtype,rseqid) {
  var callback = this._reqs[rseqid] || function() {};
  delete this._reqs[rseqid];
  if (mtype == Thrift.MessageType.EXCEPTION) {
    var x = new Thrift.TApplicationException();
    x.read(input);
    input.readMessageEnd();
    return callback(x);
  }
  var result = new CategoriesService_saveCategory_result();
  result.read(input);
  input.readMessageEnd();

  callback(null);
};
var CategoriesServiceProcessor = exports.Processor = function(handler) {
  this._handler = handler;
};
CategoriesServiceProcessor.prototype.process = function(input, output) {
  var r = input.readMessageBegin();
  if (this['process_' + r.fname]) {
    return this['process_' + r.fname].call(this, r.rseqid, input, output);
  } else {
    input.skip(Thrift.Type.STRUCT);
    input.readMessageEnd();
    var x = new Thrift.TApplicationException(Thrift.TApplicationExceptionType.UNKNOWN_METHOD, 'Unknown function ' + r.fname);
    output.writeMessageBegin(r.fname, Thrift.MessageType.EXCEPTION, r.rseqid);
    x.write(output);
    output.writeMessageEnd();
    output.flush();
  }
};
CategoriesServiceProcessor.prototype.process_getAllCategories = function(seqid, input, output) {
  var args = new CategoriesService_getAllCategories_args();
  args.read(input);
  input.readMessageEnd();
  if (this._handler.getAllCategories.length === 0) {
    Q.fcall(this._handler.getAllCategories.bind(this._handler)
    ).then(function(result) {
      var result_obj = new CategoriesService_getAllCategories_result({success: result});
      output.writeMessageBegin("getAllCategories", Thrift.MessageType.REPLY, seqid);
      result_obj.write(output);
      output.writeMessageEnd();
      output.flush();
    }).catch(function (err) {
      var result;
      result = new Thrift.TApplicationException(Thrift.TApplicationExceptionType.UNKNOWN, err.message);
      output.writeMessageBegin("getAllCategories", Thrift.MessageType.EXCEPTION, seqid);
      result.write(output);
      output.writeMessageEnd();
      output.flush();
    });
  } else {
    this._handler.getAllCategories(function (err, result) {
      var result_obj;
      if ((err === null || typeof err === 'undefined')) {
        result_obj = new CategoriesService_getAllCategories_result((err !== null || typeof err === 'undefined') ? err : {success: result});
        output.writeMessageBegin("getAllCategories", Thrift.MessageType.REPLY, seqid);
      } else {
        result_obj = new Thrift.TApplicationException(Thrift.TApplicationExceptionType.UNKNOWN, err.message);
        output.writeMessageBegin("getAllCategories", Thrift.MessageType.EXCEPTION, seqid);
      }
      result_obj.write(output);
      output.writeMessageEnd();
      output.flush();
    });
  }
};
CategoriesServiceProcessor.prototype.process_saveCategory = function(seqid, input, output) {
  var args = new CategoriesService_saveCategory_args();
  args.read(input);
  input.readMessageEnd();
  if (this._handler.saveCategory.length === 1) {
    Q.fcall(this._handler.saveCategory.bind(this._handler),
      args.category
    ).then(function(result) {
      var result_obj = new CategoriesService_saveCategory_result({success: result});
      output.writeMessageBegin("saveCategory", Thrift.MessageType.REPLY, seqid);
      result_obj.write(output);
      output.writeMessageEnd();
      output.flush();
    }).catch(function (err) {
      var result;
      result = new Thrift.TApplicationException(Thrift.TApplicationExceptionType.UNKNOWN, err.message);
      output.writeMessageBegin("saveCategory", Thrift.MessageType.EXCEPTION, seqid);
      result.write(output);
      output.writeMessageEnd();
      output.flush();
    });
  } else {
    this._handler.saveCategory(args.category, function (err, result) {
      var result_obj;
      if ((err === null || typeof err === 'undefined')) {
        result_obj = new CategoriesService_saveCategory_result((err !== null || typeof err === 'undefined') ? err : {success: result});
        output.writeMessageBegin("saveCategory", Thrift.MessageType.REPLY, seqid);
      } else {
        result_obj = new Thrift.TApplicationException(Thrift.TApplicationExceptionType.UNKNOWN, err.message);
        output.writeMessageBegin("saveCategory", Thrift.MessageType.EXCEPTION, seqid);
      }
      result_obj.write(output);
      output.writeMessageEnd();
      output.flush();
    });
  }
};
